var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-download-file",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.778,
    height: 17.315,
    viewBox: "0 0 20.778 17.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M11.194,14.121a.648.648,0,0,1-.469-.2L6.18,9.158a.65.65,0,0,1,.469-1.1H9.03V3.082A1.084,1.084,0,0,1,10.112,2h2.164a1.084,1.084,0,0,1,1.082,1.082V8.06H15.74a.65.65,0,0,1,.469,1.1L11.664,13.92A.648.648,0,0,1,11.194,14.121Z",
    transform: "translate(-0.805 -2)",
    fill: "#0c4523"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M19.263,21.463H1.515A1.517,1.517,0,0,1,0,19.948v-.433A1.517,1.517,0,0,1,1.515,18H19.263a1.517,1.517,0,0,1,1.515,1.515v.433A1.517,1.517,0,0,1,19.263,21.463Z",
    transform: "translate(0 -4.148)",
    fill: "#0c4523"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadFile);
export default __webpack_public_path__ + "static/media/ic-download-file.02546052ff73cee2c2dcc54eac3e97e1.svg";
export { ForwardRef as ReactComponent };